import { ArrowLeft, ArrowRight, Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/Button";
import { SecondaryButton } from "@/components/buttonVariants";

interface BuildPabFooterProps {
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  showBack?: boolean;
  showNext?: boolean;
  showNextLeadIcon?: boolean;
  /**
   * Swaps the trailing ArrowRight for a leading icon instead (e.g. a lock for
   * a "Pay Now" action, per Figma node 184:5494) and shows a spinner in its
   * place while `nextLoading` is true. Both default to the original
   * Continue/Next look so every other step is unaffected.
   */
  nextLeftIcon?: React.ReactNode;
  nextLoading?: boolean;
}

export const BuildPabFooter = ({
  onBack,
  onNext,
  nextLabel = "Continue",
  nextDisabled = false,
  showBack = true,
  showNext = true,
  showNextLeadIcon = false,
  nextLeftIcon,
  nextLoading = false,
}: BuildPabFooterProps) => {
  return (
    <div className="sticky bottom-0 z-20 border-t border-secondary-200 dark:border-surface-border bg-surface-card dark:bg-surface-card">
      <div className="flex flex-wrap items-center justify-end gap-3 px-4 py-4 sm:px-6 lg:px-8">
        {showBack && onBack && (
          <SecondaryButton
            onClick={onBack}
            leftIcon={<ArrowLeft size={16} />}
            className="h-[52px]"
          >
            Back
          </SecondaryButton>
        )}

        {showNext && onNext && (
          <Button
            onClick={onNext}
            disabled={nextDisabled || nextLoading}
            className="h-[52px] rounded-[10px] bg-primary-gradient px-7 py-3 text-[15px] font-semibold text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <span className="flex items-center gap-2">
              {nextLoading ? (
                <Loader2 size={16} className="animate-spin" />
              ) : (
                nextLeftIcon ?? (showNextLeadIcon && <Sparkles size={16} />)
              )}
              {nextLoading ? "Processing…" : nextLabel}
              {!nextLeftIcon && !nextLoading && <ArrowRight size={16} />}
            </span>
          </Button>
        )}
      </div>
    </div>
  );
};
